<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" option="Last 30 days" hide-details/>
        </v-col>
        <v-col cols="3" v-if="sites.length>1">
          <v-autocomplete label="Site" dense outlined hide-details :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="siteId" item-text="name" item-value="id" @change="refresh()"/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete label="Excise" dense outlined class="text-body-2" :items="exciseCodes" v-model="exciseType" hide-details @change="refresh()"/>
        </v-col>

        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Spirits activity', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import excise from '@/plugins/excise'
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsSpiritsActivity',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      siteId: null,
      loading: true,
      initialBalance: 0,
      total: 0,
      transactions: [],
      excise,
      exciseCodes: [],
      exciseType: null
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true, {B263:true,B266:true});
    }
  },
  async created() {
    this.$emit('name', 'Spirits activity')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
    this.exciseCodes = [{text:'All',value:null},{divider:true}, ...this.excise.spiritsExciseTypes()];
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsSpiritActivity($from:Date!,$to:Date!,$siteId:ID, $excise:Excise) {
                                                spiritsBalanceTo(date:$from,siteId:$siteId)
                                                spiritsActivity(from:$from,to:$to,siteId:$siteId,excise:$excise) {
                                                  date,description,volume,alcoholName,vesselType,vesselName,excise
                                                }
                                              }`,
                                          {from:this.from,to:this.to,siteId:this.siteId,excise:this.exciseType});
      if (!results.error) {
        this.initialBalance = results.data.spiritsBalanceTo;
        this.transactions = results.data.spiritsActivity;
        let balance = this.initialBalance;
        this.total = 0;
        for (const transaction of this.transactions) {
          this.total += transaction.volume;
          balance += transaction.volume;
          transaction.balance = balance;
        }
      }
      this.loading = false;

    },

    report() {
    const lines = [
                  `<style>
                    @page {size:landscape}
                    .reports-spirits-activity {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .reports-spirits-activity th {height:36px;padding:0 16px;vertical-align:middle}
                    .reports-spirits-activity .spacer {height:18px}
                    .reports-spirits-activity td {height:36px;padding:0 16px;vertical-align:middle}
                    .reports-spirits-activity .title {font-size:18px;text-transform:uppercase}
                    .reports-spirits-activity .sup-title {font-weight:normal;font-size:22px}
                    .reports-spirits-activity .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                    .reports-spirits-activity .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .reports-spirits-activity .text-left {text-align:left}
                    .reports-spirits-activity .text-right {text-align:right}
                    .reports-spirits-activity .font-weight-bold {font-weight:bold}
                    .reports-spirits-activity .total-row {font-weight:bold}
                  </style>
                   <table class="reports-spirits-activity">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">Spirits activity</th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">${this.dateDisplay}</th>
                        </tr>

                        <tr class="header">
                          <th width="${this.exciseType?14:10}%" class="text-left">Date</th>
                          <th width="${this.exciseType?38:35}%" class="text-left">Activity/Excise</th>
                          <th width="${this.exciseType?32:28}%" class="text-left">Spirit/Vessel</th>
                          <th width="${this.exciseType?15:11}%" class="text-right">Volume</th>
                          ${this.exciseType ? '' : '<th width="15%" class="text-right">Balance</th>'}
                        </tr>
                      </thead>
                      <tbody>`
    ];
    if (!this.exciseType)
      lines.push(`<tr><td/><td>Balance forward</td><td/><td/><td class="text-right">${this.$number(this.initialBalance,3)} LAA</td>`);
    for (const transaction of this.transactions) {
      lines.push(`<tr>`);
      lines.push(`<td>${this.$formatDate(transaction.date)}</td>`);
      lines.push(`<td>${transaction.description}<br/>${this.exciseCode(transaction)}</td>`);
      lines.push(`<td>${transaction.alcoholName}<br/>${transaction.vesselName}</td>`);
      lines.push(`<td class="text-right">${this.$number(transaction.volume,3)} LAA</td>`);
      if (!this.exciseType)
        lines.push(`<td class="text-right">${this.$number(transaction.balance,3)} LAA</td>`);
      lines.push(`</tr>`);
      lines.push(`<tr><td colspan="5" class="spacer"/></tr>`);
    }
    lines.push(`<tr><td/><td>Total</td><td/><td class="text-right">${this.$number(this.total,3)} LAA</td><td/>`);
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },
    exciseCode(transaction) {
      const code = this.exciseCodes.find(e => e.value === transaction.excise);
      return code ? code.text : '';
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,,`,
                      `"Spirits activity",,,,`,
                      `"${this.dateDisplay}",,,,`,
                      `"Date","Activity/Excise","Spirit/Vessel","Volume","${this.exciseType ? '': 'Balance'}"`
                    ];
      if (!this.exciseType)
        lines.push(`,"Balance forward",,,"${this.$number(this.initialBalance,3)}"`);
      for (const transaction of this.transactions) {
        lines.push(`"${transaction.date}","${transaction.description}","${transaction.alcoholName}","${this.$number(transaction.volume,3)}","${this.exciseType?'':this.$number(transaction.balance,3)}"`);
        lines.push(`,"${this.exciseCode(transaction)}","${transaction.vesselName}",,`);
      }
      lines.push(`,"Total",,"${this.$number(this.total,3)}",`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Spirit activity.csv');
    }
  }
}
</script>